export default __webpack_public_path__ + "static/media/Morocco-Flag-icon.feb06589.png";